import { Col, Flex, Row, Typography, usePaypingContext } from "@payping/web-components";
import { FC, ReactNode, useEffect, useState } from "react";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { LightBulb } from "@payping/icons";
import styles from "./FormLayout.module.scss";

interface Props {
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  instructions?: ReactNode;
  // we use this prop when the content of instructions are so much that we cant put them in regular height of instructions so we difined such prop like this for the unseen days like this
  height?: string | undefined;
}

export const FormLayout: FC<Props> = (props) => {
  const { title, description, instructions, children } = props;
  const [, setIsSmall] = useState<boolean>();
  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;
  const { t } = useAppTranslation();

  const childrenElement = (
    <Col
      xs={24}
      md={16}
      lg={12}
      className={`tw:h-[calc(100svh - 200px)] tw:w-full tw:overflow-y-auto ${styles.example}`}
    >
      <div>
        {title}
        {children}
      </div>
    </Col>
  );
  const instructionsElement = instructions ? (
    <Col
      xs={24}
      md={8}
      lg={12}
      className="background--gray100 tw:sticky tw:top-px tw:flex tw:flex-col tw:justify-center"
    >
      <Flex vertical gap={"middle"} justify={"center"} align={"center"} className={"background--gray100 p-2"}>
        <Flex vertical gap={"small"} justify={"center"} align={"center"} className={"tw:mb-4!"}>
          <LightBulb width={54} strokeWidth={"0.7"} />
          <Typography.Title level={5} className={"tw:m-0!"}>
            {t("common.instructions")}
          </Typography.Title>
        </Flex>
        <Flex vertical gap={32}>
          <Flex vertical gap={32} className="background--gray100 color--gray700 tw:leading-5">
            {instructions}
          </Flex>
          {/* Confidentiality Statement  NOTE:(which should be on all instructions on desktop and will be hidden on mobile) */}
          <p className={"color--gray500 tw:align-center tw:flex tw:text-center tw:leading-5"}>
            {t("settings.confidentialStatement")}
          </p>
        </Flex>
      </Flex>
    </Col>
  ) : null;

  function handleResize() {
    const width = window.innerWidth;
    if (width < 480) setIsSmall(true);
    else setIsSmall(false);
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Row
      className={"tw:w-full"}
      justify={"start"}
      gutter={[24, 24]}
      // this margin is for  chat at the bottom of the screen, which is 54 + 14 in small size & 60 + 40 + 20 in larger sizes
      // style={{ marginBottom: isSmall ? 68 : 120 }}
    >
      {description ? <Col xs={24}>{description}</Col> : null}
      {md ? childrenElement : instructionsElement}
      {md ? instructionsElement : childrenElement}
    </Row>
  );
};
